type SizeUnit = 'byte' | 'kilobyte' | 'megabyte'

/**
 * Localised through Intl rather than a hard-coded "KB", which would be one more
 * English string baked into an interface that ships in two languages.
 *
 * Bytes below a kilobyte are shown as bytes. Rounding them all up to "1 kB"
 * made every small file in the library look identical, which is exactly the
 * moment a size column stops being worth its width.
 */
export function formatSize(bytes: number, locale: string): string {
  const megabytes = bytes / 1024 / 1024
  const kilobytes = bytes / 1024

  const [unit, value]: [SizeUnit, number] =
    megabytes >= 1 ? ['megabyte', megabytes] : kilobytes >= 1 ? ['kilobyte', kilobytes] : ['byte', bytes]

  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'short',
    maximumFractionDigits: unit === 'byte' ? 0 : 1,
  }).format(value)
}
